export default __webpack_public_path__ + "static/media/E18.2b8f4161.jpg";